import { toLocalISO } from 'routes/Pages/GenTask/components/SharedFormFields';

export const TYPE_OF_PURCHASE_REQ_FORM = 'Purchase';

export const DEFAULT_CLOCK_IN_DATA = {
  date_Time: toLocalISO(),
  doYouDriveACompanyVan: null,
  vanRegistration: '',
  machine: '',
  forestSPNumber: null,
  additionalInformation: '',
  haveCompletedVanDriverWalkAroundCheckSheet: false,
};
export const DEFAULT_VEHICAL_CHECK_LIST = {
  goodVisibility: '',
  drivingControlsSeat: '',
  windscreenWasherWipers: '',
  tachographCalibrated: '',
  allInstruments: '',
  noAirleaksOrPressureDrop: '',
  vehicleSittingSquare: '',
  taxInsurance: '',
  wheelsGoodCondition: '',
  allLightsReflectors: '',
  exhaustSecure: '',
  airElectrical: '',
  vehicleAccess: '',
  vehicleBody: '',
  fifthWheel: '',
  trailerParkBrake: '',
  airSuspension: '',
  engineOil: '',
  steeringAndBrakes: '',
  loadsSecured: '',
  tachographSpeedometer: '',
  abSandEBS: '',
  other: '',
  checkRolloverCovers: '',
};

export const DEFAULT_HARVESTING_CLOSING_DATA = {
  date_Time: toLocalISO(),
  wasTheirTopsLeftToOneSideForTheForwarder: null,
  reasonForNonProductiveHours: '',
  subsistenceTracking: false,
  machine: null,
  forestSPNumber: null,
  total_M3: 0,
  total_M3PerHr: 0,
  overnightStay: 'No',
  fullNameAccommodation: '',
  additionalInformation: '',
  species: null,
  movedLocationForSignal: false,
  wasTheirTopsLeftToOneSideForTheForwarder: '',
  wasTheirTopsLeftToOneSideForTheForwarderReason: '',
  unitOfMeasure: 'M3',
  totalValue: 0
};
export const DEFAULT_HARVESTING_MAINTENANCE_CHECK_LIST = {
  harvestingMaintenanceFillDiesel: null,
  harvestingMaintenanceGreaseHeads: null,
  harvestingMaintenanceGreaseCrane: null,
  harvestingMaintenanceGreaseBaseUnit: null,
  harvestingMaintenanceCheckEngineOilLevel: null,
};

export const FORWARDING_MAINTENANCE_CHECK_LIST = {
  forwardingMaintenanceFillDiesel: null,
  forwardingMaintenanceGreaseGrab: null,
  forwardingMaintenanceGreaseCrane: null,
  forwardingMaintenanceGreaseBaseUnit: null,
  forwardingMaintenanceCheckEngineOilLevel: null,
};
export const FORWARDING_DEFAULT_DATA = {
  date_Time: toLocalISO(),
  reasonForNonProductiveHours: '',
  subsistenceTracking: false,
  machine: null,
  forestSPNumber: null,
  total_M3: 0,
  total_M3PerHr: 0,
  overnightStay: 'No',
  fullNameAccommodation: '',
  additionalInformation: '',
  species: null,
  movedLocationForSignal: false,
  unitOfMeasure: 'M3',
  totalValue: 0
};
export const OHER_WORK_CLOSE_DEFAULT_DATA = {
  date_Time: toLocalISO(),
  subsistenceTracking: false,
  machine: null,
  overnightStay: 'No',
  fullNameAccommodation: '',
  additionalInformation: '',
};

export const DEFAULT_COMPLETED_FOREST_DATA = {
  date_Time: toLocalISO().substring(0, 16),
  machine: null,
  forestSPNumber: null,
  species: null,
  total_M3PerHr: 0,
};
export const DEFAULT_STOCK_TAKE_DATA = {
  date_Time: toLocalISO().substring(0, 16),
  forestSPNumber: null,
  species: null,
  additionalInformation: '',
};

export const DEFAULT_EXPENSE_CLAIM_DATA = {
  expenseClaim: 0,
  additionalInformation: '',
};
export const DEFAULT_OTHER_WORK_DATA = {
  date_Time: toLocalISO().substring(0, 16),
  durationInHours: 0,
  missingHours: 0,
  nonProductiveHours: 0,
  reasonForNonProductiveHours: '',
  additionalInformation: '',
};
export const DEFAULT_HOLIDAY_DATA = {
  date_Time: toLocalISO().substring(0, 16),
  totalNumberOfDays: 0,
  additionalInformation: '',
};
